var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGrilledFish = function SvgGrilledFish(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.32 8.297 3.856-2.57v5.141l-3.856-2.57Z",
    fill: "#FF5454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.238 14.69 2.571-1.929v3.856l-2.57-1.928Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19 8.298 7.477 3.65l5.285 4.647-5.285 4.328-5.285-4.328Z",
    fill: "#1B2230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.546 14.725 3.263-2.87 3.264 2.87-3.264 2.672-3.263-2.672Z",
    fill: "#565C68"
  })));
};
export default SvgGrilledFish;